var _rect, _path, _path2, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E1EEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 17.5C22.2016 17.5 17.5 22.2016 17.5 28C17.5 33.7984 22.2016 38.5 28 38.5C33.7984 38.5 38.5 33.7984 38.5 28C38.5 22.2016 33.7984 17.5 28 17.5ZM28 36.7188C23.1859 36.7188 19.2812 32.8141 19.2812 28C19.2812 23.1859 23.1859 19.2812 28 19.2812C32.8141 19.2812 36.7188 23.1859 36.7188 28C36.7188 32.8141 32.8141 36.7188 28 36.7188Z",
    fill: "#3583EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8746 23.875C26.8746 24.1734 26.9932 24.4595 27.2041 24.6705C27.4151 24.8815 27.7013 25 27.9996 25C28.298 25 28.5842 24.8815 28.7951 24.6705C29.0061 24.4595 29.1246 24.1734 29.1246 23.875C29.1246 23.5766 29.0061 23.2905 28.7951 23.0795C28.5842 22.8685 28.298 22.75 27.9996 22.75C27.7013 22.75 27.4151 22.8685 27.2041 23.0795C26.9932 23.2905 26.8746 23.5766 26.8746 23.875ZM28.5621 26.5H27.4371C27.334 26.5 27.2496 26.5844 27.2496 26.6875V33.0625C27.2496 33.1656 27.334 33.25 27.4371 33.25H28.5621C28.6653 33.25 28.7496 33.1656 28.7496 33.0625V26.6875C28.7496 26.5844 28.6653 26.5 28.5621 26.5Z",
    fill: "#3583EE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#F5FAFF",
    strokeWidth: 8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomInfo);
export default __webpack_public_path__ + "static/media/custom-info.b60fcbaf694210a6dccde4b7dc34a63b.svg";
export { ForwardRef as ReactComponent };